import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Avatar,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import LogoutIcon from "../../assets/icons/logout-color-icon.png";
import NotificationIcon from "../../assets/icons/notification-color-icon.png";
import { AppContext } from "../../lib/Context";
import { logoutUser } from "../../services/AgentApi";
import { clearAccessToken } from "../../services/tokenStore";

const style = {
  menuButton: {
    padding: "4px 8px",
    fontSize: "0.875rem",
    color: "#000000",
  },
};

export default function ProfileMenu({ openNotifyDialog }) {
  const naviagte = useNavigate();
  const { palette } = useTheme();
  const { userData, setUserData } = React.useContext(AppContext);

  const handleLogout = async () => {
    try {
      await logoutUser();
    } catch (err) {
      // API fail ho to bhi local session clear
    } finally {
      clearAccessToken();
      setUserData(null);
      localStorage.removeItem("user_data");
      naviagte("/login");
    }
  };

  return (
    <PopupState variant="popover" popupId="demo-popup-menu">
      {(popupState) => (
        <React.Fragment>
          <Button
            {...bindTrigger(popupState)}
            variant="contained"
            disableRipple
            startIcon={
              <Avatar
                sx={{ height: 32, width: 32, border: "2px solid #ffffff" }}
                src={userData?.image}
              />
            }
            endIcon={
              <KeyboardArrowDownIcon
                htmlColor="#ffffff"
                sx={{ fontSize: "1.5rem !important" }}
              />
            }
            sx={{
              display: { xs: "none", sm: "flex" },
              justifyContent:"space-between",
              width: 160,
              height: 45,
              background: palette.gradient.button,
              border: "none",
              borderRadius: "100px",
              boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
              "&:hover": {
                boxShadow: "none",
              },
            }}
          >
            <Typography variant="body2" noWrap>
              {userData?.username}
            </Typography>
          </Button>
          <Menu
            disableScrollLock
            {...bindMenu(popupState)}
            PaperProps={{
              sx: {
                top: "70px !important",
                width: userData?.designation == "Admin" ? "160px" : "auto",
              },
            }}
          >
            <Stack
              justifyContent={"center"}
              alignItems={"center"}
              width={"100%"}
              p="5px"
            >
              <Avatar
                sx={{ height: 60, width: 60 }}
                src={
                 userData?.image
                }
              />
              <Typography
                variant="h6"
                fontSize={"0.875rem"}
                fontWeight={"400"}
                color={"primary"}
                textAlign={"center"}
                whiteSpace={"break-spaces"}
              >
                {userData?.username} 
              </Typography>
            </Stack>
            {userData?.designation == "Sales Agent" && (
              <MenuItem
                onClick={() => {
                  openNotifyDialog.current.isVisible();
                  popupState.close();
                }}
                sx={style.menuButton}
              >
                <ListItemIcon sx={{ minWidth: "25px !important" }}>
                  <img src={NotificationIcon} alt={"setting-icon"} width={20} />
                </ListItemIcon>
                <ListItemText
                  primary={"See all notifications"}
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontSize: "0.75rem",
                      color: "text.coolGrey",
                    },
                  }}
                />
              </MenuItem>
            )}
            <MenuItem
              onClick={() => {
                popupState.close();
                handleLogout();
              }}
              sx={{ ...style.menuButton, mt: 1 }}
            >
              <ListItemIcon sx={{ minWidth: "25px !important" }}>
                <img src={LogoutIcon} alt={"setting-icon"} width={20} />
              </ListItemIcon>
              <ListItemText
                primary={"Logout"}
                sx={{
                  "& .MuiListItemText-primary": {
                    fontSize: "0.75rem",
                    color: "text.coolGrey",
                  },
                }}
              />
            </MenuItem>
          </Menu>
        </React.Fragment>
      )}
    </PopupState>
  );
}
